export let SocialType = /*#__PURE__*/function (SocialType) {
  SocialType["Email"] = "email";
  SocialType["Facebook"] = "facebook";
  SocialType["Google"] = "google";
  return SocialType;
}({});